import React, { useState } from "react";
import { t } from "i18next";
import useEditUOM from "./edit-uom.hooks";
import TextArea from "antd/es/input/TextArea";
import { Col, Input, Row, Select, Timeline } from "antd";
import { ListUOMCategory } from "../../../../constant/dataConstant";
import PrimaryButton from "../../../../component/button/PrimaryButton";
import { UOMConvertionCode, justNumberAllowed } from "../../../../util";
import SecondaryButton from "../../../../component/button/SecondaryButton";
import HeaderPages from "../../../../component/page-components/pages-header";
import ModalSuccessUpdated from "../../../../component/modal/ModalSuccessUpdated";
import Breadcumbs from "../../../../component/page-components/breadcumbs/breadcumbs";
import NotifFailedSaved from "../../../../component/modal/NotifFailedSaved";
import ModalConfirmLeave from "../../../../component/modal/ModalConfirmLeave";
import { ROUTES } from "../../../../constant/routeConstant";
import {
  ActiveDotIcon,
  BackIcon,
  CloseIcon,
  InactiveDotIcon,
} from "../../../../asset";

const EditUOM = () => {
  const {
    handleBack,
    data,
    uom_name,
    uom_category_code,
    uom_category,
    uom_description,
    uom_conversions_to,
    visible,
    _onChange,
    _onSave,
    handleOk,
    err,
    error,
    failedMessages,
    failedModalOpen,
    setFailedModalOpen,
    showConfirm,
    setShowConfirm,
    managementHistoryList,
    convertTimestamp,
    convertToTime,
  } = useEditUOM();

  const [userManagementOpen, setUserManagementOpen] = useState(false);

  const NewHandleKeyPress = (event) => {
    const regex = /^[0-9,]+$/; // Regex yang diinginkan

    // Allow only number and comma input, but not at the beginning
    if (!regex.test(event.key)) {
      event.preventDefault();
    }
  };

  return (
    <>
      <div className="p-5 h-fit">
        <ModalConfirmLeave
          visible={showConfirm}
          action={() => setShowConfirm(false)}
          route={ROUTES.UOM.LIST}
        />

        <Breadcumbs
          jmlLevel={4}
          menuLevel1={`Setup`}
          menuLevel2={`Profile Configuration`}
          menuLevel3={`Units of Measurement`}
          menuLevel4={`Edit ${data?.uom_name} - ${data?.uom_category_code}`}
        />

        <div className="flex items-center justify-between my-[31px]">
          <div
            className="flex items-center gap-[22px] cursor-pointer"
            onClick={() => handleBack()}
          >
            <img src={BackIcon} alt="" />
            <h1
              className="font-sans-bold text-2xl"
              id="title"
            >{`Edit ${data?.uom_name} - ${data?.uom_category_code}`}</h1>
          </div>

          <div
            className="bg-[#EEEEEE] rounded-[6px] px-[12px] py-[7px] cursor-pointer"
            onClick={() => setUserManagementOpen(true)}
          >
            <p className="text-[#666666]">
              {t("USER_DETAIL:CREATED_BY")} <strong>{data?.created_by}</strong>{" "}
              {t("USER_DETAIL:ON")}{" "}
              <strong>{convertTimestamp(data?.created_at, true)}</strong> |{" "}
              {t("USER_DETAIL:LAST_MODIFIED_BY")}{" "}
              <strong>{data?.updated_by}</strong> {t("USER_DETAIL:ON")}{" "}
              <strong>{convertTimestamp(data?.updated_at, true)}</strong>
            </p>
          </div>
        </div>

        <div className=" bg-white-100 p-5 rounded-[10px] min-h-96 mt-5 pb-10">
          <p className=" font-roboto text-lg text-black-100 font-bold">
            Detail to Add UOM
          </p>
          <Row className="mt-5">
            <Col span={12}>
              <div>
                <p className=" mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]">
                  {t("UOM Category")}
                </p>
                <Select
                  style={{ width: "80%" }}
                  size="large"
                  options={ListUOMCategory()}
                  value={uom_category}
                  onChange={(evt) => {
                    _onChange(evt, "uom_category");
                  }}
                  placeholder={t("COMMON:SELECT", { field: t("UOM Category") })}
                  status={error?.uom_category ? "error" : null}
                />
              </div>
              <div className="text-red-100">
                {err ? err : error?.uom_category}
              </div>
              <div className="mt-4">
                <p className=" mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]">
                  {t("UOM Name")}
                </p>
                <Input
                  style={{ width: "80%" }}
                  size="large"
                  value={uom_name}
                  onChange={(evt) => {
                    _onChange(evt, "uom_name");
                  }}
                  placeholder={t("COMMON:TYPE", { field: t("UOM Name") })}
                  status={error?.uom_name ? "error" : null}
                />
              </div>
              <div className="text-red-100">{err ? err : error?.uom_name}</div>
              <div className="mt-4">
                <p className=" mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]">
                  {t("UOM Category Code")}
                </p>
                <Input
                  style={{ width: "80%" }}
                  size="large"
                  maxLength={3}
                  value={uom_category_code}
                  onChange={(evt) => {
                    _onChange(evt, "uom_category_code");
                  }}
                  placeholder={t("COMMON:TYPE", {
                    field: t("UOM Category Code"),
                  })}
                  status={error?.uom_category_code ? "error" : null}
                />
              </div>
              <div className="text-red-100">
                {err ? err : error?.uom_category_code}
              </div>
              <div className="mt-4">
                <p className=" mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]">
                  {t("UOM Conversions")}
                </p>
                <Row style={{ width: "80%" }}>
                  <Col span={6}>
                    <Row>
                      <Col span={10}>
                        <Input
                          style={{ borderRadius: "0px", textAlign: "center" }}
                          size="large"
                          value={1}
                          disabled
                        />
                      </Col>
                      <Col span={14}>
                        <Input
                          style={{ borderRadius: "0px", textAlign: "center" }}
                          size="large"
                          value={uom_category_code}
                          defaultValue="X"
                          disabled
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col
                    span={2}
                    style={{ textAlign: "center", alignItems: "center" }}
                  >
                    <p className="font-roboto-medium text-[16px] text-[#1D1D1D]">
                      =
                    </p>
                  </Col>
                  <Col span={16}>
                    <Input
                      size="large"
                      addonAfter={UOMConvertionCode(uom_category)}
                      placeholder="Fill Category & Code First"
                      value={uom_conversions_to}
                      disabled={
                        uom_category && uom_category_code ? false : true
                      }
                      onChange={(evt) => {
                        _onChange(evt, "uom_conversions_to");
                      }}
                      onKeyPress={(evt) => NewHandleKeyPress(evt)}
                      showCount={false}
                      status={error?.uom_conversions_to ? "error" : null}
                    />
                    <div className="text-red-100">
                      {err ? err : error?.uom_conversions_to}
                    </div>
                  </Col>
                </Row>
              </div>
              <div className="mt-2">
                <p className=" mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]">
                  {t("Description UOM")}
                </p>
                <TextArea
                  style={{ width: "80%" }}
                  size="large"
                  value={uom_description}
                  onChange={(evt) => {
                    _onChange(evt, "uom_description");
                  }}
                  placeholder={t("COMMON:TYPE", {
                    field: t("LOGIN_COMPLETION:LBL_ADDRESS"),
                  })}
                  status={error?.uom_description ? "error" : null}
                />
              </div>
              <div className="text-red-100">
                {err ? err : error?.uom_description}
              </div>
            </Col>
            <Col span={12}></Col>
          </Row>
        </div>

        <aside
          className={
            userManagementOpen
              ? "duration-300 ease-out transition-all right-0 w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto"
              : "duration-300 ease-out transition-all right-[-400px] w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto"
          }
        >
          <button
            className="absolute top-[21px] right-[21px]"
            onClick={() => setUserManagementOpen(false)}
          >
            <img src={CloseIcon} alt="" />
          </button>

          <h3 className="font-sans font-[600] text-[#1D1D1D] text-[20px]">
            {t("USER_DETAIL:DATA_MANAGEMENT_HISTORY")}
          </h3>
          <p className="font-sans font-[400] text-[#818181] text-[12px] mb-[24px]">
            {t("USER_DETAIL:CREATED_BY")} <strong>{data?.created_by}</strong>{" "}
            {t("USER_DETAIL:ON")}{" "}
            <strong>{convertTimestamp(data?.created_at)}</strong>
          </p>

          <div>
            <Timeline>
              {managementHistoryList.map((item, index) => {
                if (index === 0) {
                  return (
                    <Timeline.Item dot={<img src={ActiveDotIcon} />}>
                      <div className="flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]">
                        <h4 className={"text-[#CF0000] font-[500] text-[14px]"}>
                          {t("USER_DETAIL:LAST_MODIFIED")}
                        </h4>
                        <h4 className="font-[500] text-[14px] text-[#424242]">
                          {item.alias_name}
                        </h4>
                        <p className="font-[400] text-[14px]">{`${convertTimestamp(
                          item.created_at
                        )} • ${convertToTime(item.created_at)}`}</p>
                      </div>
                    </Timeline.Item>
                  );
                } else {
                  return (
                    <Timeline.Item dot={<img src={InactiveDotIcon} />}>
                      <div className="flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]">
                        <h4 className={"font-[500]"}>
                          {t("USER_DETAIL:MODIFIED")}
                        </h4>
                        <h4 className="font-[500] text-[14px] text-[#424242]">
                          {item.alias_name}
                        </h4>
                        <p className="font-[400] text-[14px]">{`${convertTimestamp(
                          item.created_at
                        )} • ${convertToTime(item.created_at)}`}</p>
                      </div>
                    </Timeline.Item>
                  );
                }
              })}
            </Timeline>
          </div>
        </aside>
      </div>
      <div className="flex flex-row-reverse gap-[16px] px-5 m-5">
        <PrimaryButton text={t("USER_DETAIL:SAVE")} action={_onSave} />
        <SecondaryButton action={handleBack} text={t("COMMON:CANCEL")} />
      </div>
      <ModalSuccessUpdated isVisible={visible} onOk={handleOk} />
      <NotifFailedSaved
        visible={failedModalOpen}
        message={failedMessages}
        action={() => {
          setFailedModalOpen(false);
        }}
      />
    </>
  );
};

export default EditUOM;
